import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "message" }

import { useCortonaViewerStore } from '@/stores/cortonaViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartMergePage',
  emits: ["manualMergeDone"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const localCart = () => JSON.parse(localStorage.getItem('cart')) || [];

const loggedInCart = () => {
  const cortonaViewerStore = useCortonaViewerStore();
  return cortonaViewerStore.cartItems;
};

const needsManualMerge = () => localCart().length > 0 && loggedInCart().length > 0;
const needsSimpleMerge = () => localCart().length > 0 && loggedInCart().length === 0;

const mergeDeclined = () => emit('manualMergeDone');

const merge = async () => {
  const cortonaViewerStore = useCortonaViewerStore();
  await cortonaViewerStore.transferLocalCart();
  emit('manualMergeDone');
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "card" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('cart.merge-confirmation')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_card_actions, { class: "justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            variant: "outlined",
            class: "confirm-button",
            color: "blue",
            onClick: mergeDeclined
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('no')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_btn, {
            variant: "outlined",
            class: "confirm-button",
            color: "green",
            onClick: merge
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('yes')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})